const getters = {
    token: state => state.user.token,
    module: state => state.user.module,
    streetList: state => state.user.streetList,
    componentRoutes: state => state.router.componentRoutes,
    componentOperation: state => state.router.componentOperation
  }
  export default getters
  